import { createStyles, makeStyles, Typography, Theme } from '@material-ui/core';
import TGLoginButton, { TGLoginButtonType } from './TGLoginButton';
import { useThemeColors } from '../../utils/useThemeColors';

interface LegalDisclaimerViewProps {
  legalDisclaimerText?: string | null;
  onDisclaimerAccepted: () => void;
}

const LegalDisclaimerView = (props: LegalDisclaimerViewProps) => {
  const { legalDisclaimerText, onDisclaimerAccepted } = props;
  const colors = useThemeColors();
  const classes = useStyles({ colors });

  return (
    <div className={classes.legalContainer} style={{ marginTop: '5px', width: '287px' }}>
      <Typography className={classes.title}>Legal Disclaimer</Typography>
      <div className={classes.legalContainer}>
        <div className={classes.legalText}>{legalDisclaimerText}</div>
        <div style={{ marginTop: '25px' }}>
          <TGLoginButton type={TGLoginButtonType.primary} onClick={onDisclaimerAccepted}>
            <>AGREE & CONTINUE</>
          </TGLoginButton>
        </div>
      </div>
    </div>
  );
};
const useStyles = makeStyles<Theme, { colors: any }>((theme: Theme) =>
  createStyles({
    title: {
      fontSize: '24px',
      width: '287px',
      color: (props) => props.colors.black,
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: '10px',
    },
    legalContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      borderRadius: '8px',
      padding: '20px',
    },
    legalText: {
      marginTop: '15px',
      lineHeight: '24px',
      letterSpacing: '0.15px',
      whiteSpace: 'pre-wrap',
      minHeight: '50px',
      maxHeight: '360px',
      width: '287px',
      overflowY: 'auto',
      color: (props) => props.colors.black,
      fontSize: '14px',
      padding: '10px',
      borderRadius: '4px',
      border: `1px solid ${(props: any) => props.colors.grayLine}`,
      '&::-webkit-scrollbar': {
        width: '6px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: (props) => props.colors.backgroundLight,
        borderRadius: '3px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: (props) => props.colors.gray62,
        borderRadius: '3px',
        '&:hover': {
          backgroundColor: (props) => props.colors.gray74,
        },
      },
    },
  })
);

export default LegalDisclaimerView;
